(() => {
  const aliases = {"bills": "buffalo", "packers": "green bay", "bears": "chicago", "eagles": "philadelphia", "bengals": "cincinnati", "browns": "cleveland", "cowboys": "dallas", "broncos": "denver", "lions": "detroit", "texans": "houston", "colts": "indianapolis", "jaguars": "jacksonville", "chiefs": "kansas city", "raiders": "las vegas", "patriots": "new england", "steelers": "pittsburgh", "49ers": "san francisco", "niners": "san francisco", "seahawks": "seattle", "buccaneers": "tampa bay", "titans": "tennessee", "commanders": "washington", "ravens": "baltimore", "panthers": "carolina", "vikings": "minnesota"};
  window.wellServedSearchQuery = value => {
    const query = String(value || '').trim();
    const words = query.toLowerCase().replace(/[^a-z0-9 ]/g, ' ').split(/\s+/);
    for (const [alias, city] of Object.entries(aliases)) {
      if (words.includes(alias)) return city;
    }
    return query;
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !new URL(form.action, location.href).pathname.endsWith('/search')) return;
    const input = form.querySelector('[name="q"]');
    if (input) input.value = window.wellServedSearchQuery(input.value);
  }, true);
})();
